module.exports = __webpack_public_path__ + "img/hgro.5d995416.jpg";